<template>
  <div>
    <training-member-toolbar/>
    <div class="card mx-md-5 mt-3 mb-3 bg-form">
      <card-header
        :title="$t('trainings.approved_participation')"
        :iconName="'check-circle'"
      />
      <b-card-body>
        <b-alert v-for="error in errors" :key="error.message" v-model="popAlert"  variant="danger" dismissible>
          {{ error.message }}
        </b-alert>
        <template v-if="participation.id">
        Η αίτηση για συμμετοχή του/της {{ participation.member.surName }} {{ participation.member.firstName }} στην εκπαιδευτική ενότητα {{participation.activity.module.title}} εγκρίθηκε.
        <p/>
        <p v-if="participation.paymentType !== 'NONE'">
          Θα πρέπει να προχωρήσετε στην πληρωμή. Έχετε επιλέξει για τρόπο πληρωμής: <b>{{ depositTypes[participation.paymentType] }}</b>
        </p>
        </template>
      </b-card-body>

    </div>
  </div>
</template>

<script>
import CardHeader from '../../components/common/cardHeader.vue'
import trainingService from '../../services/training.service';
import { handleApiError } from '../../services/error.service';
import TrainingMemberToolbar from "@/components/TrainingMemberToolbar";

export default {
  components: {
    CardHeader,
    TrainingMemberToolbar,
  },
  mounted() {
    trainingService.getUserInfo(this.username).then(
      (response) => {
        this.userInfo = response.data;
        // if (!hasRole(this.userInfo, roles.training.participation)){
        //   location.replace(routes.nothing);
        // }
        this.$store.state.userInfo = this.userInfo;
        // if (this.isAdmin){
        //   this.depositTypes.push({ value: "FINANCE_DEP", text: this.$t('paymentTypeEnums.FINANCE_DEP'), enabled: true },);
        // }

      },
      (error) => {
        let errorMessage = handleApiError(error);
        this.handleError(errorMessage);
      }
    );
    this.approveParticipation(this.$route.params.id);
  },
  data() {
    return {
      userInfo: null,
      popSuccessAlert: false,
      popAlert: false,
      successMessage: null,
      errors: null,
      participation: {
        member: {},
        activity: { module: {}},
      },
      depositTypes: {
        RF_CODE: this.$t('paymentTypeEnums.RF_CODE'),
        IN_PERSON: this.$t('paymentTypeEnums.IN_PERSON'),
        ISLAND_DISCOUNT: this.$t('paymentTypeEnums.ISLAND_DISCOUNT'),
        BANK: this.$t('paymentTypeEnums.BANK'),
        FINANCE_DEP: this.$t('paymentTypeEnums.FINANCE_DEP'),
        NONE: this.$t('paymentTypeEnums.NONE'),
      },
    }
  }, 
  methods: {
    handleError(errors) {
      errors.forEach(error => {
        error.message = this.$t(`error.${error.code}`);
      })
      this.errors = errors;
      this.popAlert = errors.length>0;
    },
    approveParticipation(participationId) {
      trainingService.approveParticipation(participationId, true).then(
          (response) => {
            this.participation = response.data;
          },
          (error) => {
            this.handleError(handleApiError(error))
          }
      );
    },

  }
}
</script>